import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import { AuthProvider } from "./context/AuthContext";
import ResetPassword from "./pages/auth/ResetPassword";
import Dashboard from "./pages/dashboard/DashboardRouter";
import ProtectedRoute from "./context/ProtectedRoute";
import KycForm from "./pages/dashboard/Agency/KycForm";
import AdminRegister from "./pages/auth/AdminRegister";
import ProfilePage from "./pages/profile/ProfilePage";
import AgenciesPage from "./pages/agencies/AgenciesPage";
import AgencyDetails from "./pages/agencies/AgencyDetails";
import PccRequest from "./pages/pcc/PccRequest";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PostBookingToolset from "./pages/products/PostBookingToolsetPage";
import FAQPage from "./pages/faq/FAQPage";
import AdminNotificationsPage from "./pages/notification/AdminNotificationsPage";
import CreateProduct from "./pages/products/createNewProduct/CreateProduct";
import InviteAdmin from "./pages/manage-admins/InviteAdmin";
import ProcessPccPage from "./pages/pcc/ProcessPccPage";
import AuditLogPage from "./pages/audit-log/AuditLogPage";
import ContractPage from "./pages/contract/ContractPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/register" element={<SignupPage />} />
          <Route
            path="/auth/verify-email/:token"
            element={<VerifyEmailPage />}
          />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/agency/kyc-form" element={<KycForm />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/agencies" element={<AgenciesPage />} />
          <Route path="/agencies/:id" element={<AgencyDetails />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/dashboard/super-admin" element={<Dashboard />} />
          <Route path="/pcc-request" element={<PccRequest />} />
          <Route path="/process-pcc/:id" element={<ProcessPccPage />} />
          <Route path="/products" element={<PostBookingToolset />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/notifications" element={<AdminNotificationsPage />} />

          <Route path="/create-products" element={<CreateProduct />} />
          <Route path="/manage-admins" element={<InviteAdmin />} />
          <Route path="/audit-log" element={<AuditLogPage />} />
          <Route path="/contract" element={<ContractPage />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
